var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckBorder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8624_567)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 0C15.7712 0 17.6569 0 18.8284 1.17157C20 2.34315 20 4.22867 20 7.99972V12.0016C20 15.7718 20 17.6569 18.8284 18.8284C17.6569 20 15.7712 20 12 20H8C4.22876 20 2.34315 20 1.17157 18.8284C0 17.6569 0 15.7712 0 12V8C0 4.22876 0 2.34315 1.17157 1.17157C2.34315 0 4.22876 0 8 0H10H12ZM1 12V8C1 6.08611 1.00212 4.75129 1.13753 3.74416C1.26907 2.76579 1.50966 2.2477 1.87868 1.87868C2.2477 1.50966 2.76579 1.26907 3.74416 1.13753C4.75129 1.00212 6.08611 1 8 1H10H12C13.9139 1 15.2487 1.00212 16.2558 1.13753C17.2342 1.26907 17.7523 1.50966 18.1213 1.87868C18.4903 2.2477 18.7309 2.76579 18.8625 3.7441C18.9979 4.75118 19 6.08593 19 7.99972V12.0016C19 13.915 18.9979 15.2494 18.8625 16.2562C18.7309 17.2343 18.4904 17.7523 18.1213 18.1213C17.7523 18.4903 17.2342 18.7309 16.2558 18.8625C15.2487 18.9979 13.9139 19 12 19H8C6.08611 19 4.75129 18.9979 3.74416 18.8625C2.76579 18.7309 2.2477 18.4903 1.87868 18.1213C1.50966 17.7523 1.26907 17.2342 1.13753 16.2558C1.00212 15.2487 1 13.9139 1 12ZM14.2672 8.0431C14.5672 7.75744 14.5788 7.28271 14.2931 6.98276C14.0074 6.68281 13.5327 6.67123 13.2328 6.9569L8.5 11.4643L6.76724 9.81404C6.46729 9.52837 5.99256 9.53995 5.7069 9.8399C5.42123 10.1398 5.43281 10.6146 5.73276 10.9002L7.98276 13.0431C8.27241 13.319 8.72759 13.319 9.01724 13.0431L14.2672 8.0431Z",
    fill: "#151515"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8624_567"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckBorder);
export default __webpack_public_path__ + "static/media/check-border.17bf493a4fca7d434bff71eda421af79.svg";
export { ForwardRef as ReactComponent };